import React from "react";
import MultiSelectFilterForm from "../MultiSelectFilterForm";
import {
  mapStateToProps,
  mapDispatchToProps,
} from "../FilterToolbar/FilterToolbar.state";
import { connect } from "react-redux";

const MultiSelectFilter = ({
  actions,
  forms,
  options,
  filterName,
  appliedFilters,
}) => {
  const searchTermActions = actions.forms.multiSelectFilterForm.actions;
  const searchTermFields = forms.multiSelectFilterForm.fields;
  return (
    <MultiSelectFilterForm
      fields={searchTermFields}
      actions={searchTermActions}
      options={options}
      autocompleteValue={""}
      filterName={filterName}
      appliedFilters={appliedFilters}
    />
  );
};

const ConnectedMultiSelectFilter = connect(
  mapStateToProps,
  mapDispatchToProps
)(MultiSelectFilter);

export default ConnectedMultiSelectFilter;
